<script>

import RootHeader from 'components/root/header/main.vue'
import AppFooter from 'components/root/footer/Footer.vue'
import moduleUtils from './app/module/ModuleUtils.js'

import {mapActions} from 'vuex';

export default {
  components: { RootHeader, AppFooter },
  methods: {
      ...mapActions([
        'testConection',
        'changeUserContractVersion'
      ]),
      checkVersion() {

        let self = this;

        if (["ModuleList", "ModuleCreate", "ModuleEdit", "ModuleShow"].indexOf(self.$route.name) >= 0) {
          let businessAreaId = this.$route.params.businessAreaId;
          let systemId = this.$route.params.systemId;

          moduleUtils.resolveSystemVersion(businessAreaId, systemId)
            .then(response => {
              if (this.$route.params.systemVersion != response.id) {
                let payload = {};

                payload.businessAreaId = businessAreaId;
                payload.contractId = systemId;
                payload.version = response.id;

                this.changeUserContractVersion(payload);

                alert('Uma nova versão do sistema ' + response.name + ' está disponível, caso você queira utilizar essa nova versão, por gentileza efetue o login novamente no sistema.');

                /*
                this.$router.push({
                  name: 'SystemsList'
                });

                // TODO - PROCURAR UMA MELHOR SOLUÇÃO
                //NECESSARIO PARA ATUALIZAR O MENU QUANDO O USUARIO TEM APENAS 1 CONTRATO
                location.reload();
                */
              }
            })
        }

        setTimeout(function() {
          self.checkVersion();
        }, (600 * 1000));
      }
  },
  mounted () {

    // this.checkVersion();

    /*self.testConection()
      .then( () => {
        console.log("Testando a conexão!");
      });*/
  }
}

</script>

<style src="assets/sass/app.scss" lang="sass"></style>
<style src="assets/css/app.css"></style>
<style src="assets/css/bootstrap-override.css"></style>
<style src="assets/css/element-override.css"></style>
<style src="assets/css/helpers.css"></style>

<template>
  <div id="app">
    <PageLoader></PageLoader>
    <RootHeader/>
    <router-view></router-view>
    <AppFooter/>
  </div>
</template>



// WEBPACK FOOTER //
// App.vue?081923b9